import {
  pgTable,
  uuid,
  text,
  point,
  varchar,
  index,
} from 'drizzle-orm/pg-core';
import { defaultFields, defaultHistoryFields } from '@trashlab/api/drizzle/default';
import { SQL, sql } from 'drizzle-orm';

export const geolocation2 = pgTable(
  'geolocation2',
  {
    ...defaultFields.fieldsWithTenantId(),
    name: varchar('name', { length: 255 }).default(''),
    streetAddressPartOne: varchar('streetAddressPartOne', { length: 255 }).default(''),
    streetAddressPartTwo: varchar('streetAddressPartTwo', { length: 255 }).default(''),
    city: varchar('city', { length: 100 }).default(''),
    state: varchar('state', { length: 2 }).default(''),
    postalCode: varchar('postalCode', { length: 10 }).default(''),
    coordinates: point('coordinates', { mode: 'xy' }).notNull(),
    addressString: text('addressString')
      .notNull()
      .generatedAlwaysAs(
        (): SQL => sql`(
          COALESCE(${geolocation2.streetAddressPartOne}, '') || ' ' ||
          COALESCE(${geolocation2.streetAddressPartTwo}, '') || ' ' ||
          COALESCE(${geolocation2.city}, '') || ' ' ||
          COALESCE(${geolocation2.state}, '') || ' ' ||
          COALESCE(${geolocation2.postalCode}, '')
        )`,
      ),
    notes: text('notes').default('').notNull(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
  },
  (table) => {
    return {
      address_trgm_gist_idx: index('geolocation2_address_trgm_gist_idx').using(
        'gist',
        table.addressString.op('gist_trgm_ops'),
      ),
      coordinates_gist_idx: index('geolocation2_coordinates_gist_idx').using(
        'gist',
        table.coordinates,
      ),
      name_trgm_gist_idx: index('geolocation2_name_trgm_gist_idx').using(
        'gist',
        table.name.op('gist_trgm_ops'),
      ),
      city_idx: index('geolocation2_city_idx').on(table.city),
      state_idx: index('geolocation2_state_idx').on(table.state),
      postal_code_idx: index('geolocation2_postal_code_idx').on(table.postalCode),
      tenantId_idx: index('geolocation2_tenantId_idx').on(table.tenantId),
      createdAtTs_idx: index('geolocation2_createdAtTs_idx').on(table.createdAtTs),
      updatedAtTs_idx: index('geolocation2_updatedAtTs_idx').on(table.updatedAtTs),
    };
  },
);

export const geolocation2_history = pgTable('geolocation2_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  id: uuid('id'),
  name: varchar('name', { length: 255 }),
  streetAddressPartOne: varchar('streetAddressPartOne', { length: 255 }),
  streetAddressPartTwo: varchar('streetAddressPartTwo', { length: 255 }),
  city: varchar('city', { length: 100 }),
  state: varchar('state', { length: 2 }),
  postalCode: varchar('postalCode', { length: 10 }),
  coordinates: point('coordinates'),
  addressString: text('addressString'),
  notes: text('notes'),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
});

export type GeolocationSchema = typeof geolocation2.$inferSelect; 